// extracted by mini-css-extract-plugin
export default {"textContainer":"textContainer___GWcTu","moreEllipses":"moreEllipses___CXjpY"};